import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";
import { intentionalInteractionCounterFn } from "../autoclick_utils";

class AutoclickBehaviorLastInteractionAndCount extends AutoclickBehaviorAbstract {
  init() {
    this._counter = intentionalInteractionCounterFn(this.getBehaviorCount());
  }

  onInteraction(e) {
    this.setCurrentCount(this._counter(e));

    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorLastInteractionAndCount;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorLastInteractionAndCount.js